/**
 * Copy de cara al cliente de la página pública `/perron-coins` y del enlace del footer (A0·web de Perrón Coins), en
 * UN único archivo para fijarlo verbatim en `perron-coins.copy.spec.ts`. Tuteo, español neutro, sin voseo y sin
 * emojis; solo cadenas, con los parámetros como `{x}`.
 *
 * El valor del Coin NUNCA va escrito aquí (W4): `{valor}` sale de `coin_value_crc` de la API, pintado con `formatCrc`.
 * Y va en futuro («valdrá»): los Coins aún no se gastan como dinero (madre B3).
 */
export const PERRON_COINS_COPY = {
  NAV_LINK: 'Perrón Coins',

  SEO_TITLE: 'Perrón Coins',
  SEO_DESCRIPTION:
    'Gana Perrón Coins con cada compra en Perrón Store, súmalos con códigos y con tu QR en caja, y desbloquea el acceso VIP a precompras exclusivas.',

  BREADCRUMB_HOME: 'Inicio',

  EYEBROW: 'Programa de recompensas',
  TITLE: 'Perrón Coins',
  INTRO:
    'Cada compra en Perrón Store te deja Coins. Júntalos, desbloquea el acceso VIP a precompras exclusivas y prepárate para todo lo que viene.',

  EARN_TITLE: 'Cómo ganas Coins',
  EARN_PURCHASE_TITLE: 'Comprando',
  /**
   * El «₡100» SÍ es literal: es el divisor de GANANCIA (`earn_rate_divisor` de la API, D2), que la API no expone. No es
   * el valor de canje del Coin (`coin_value_crc`), que nunca se escribe aquí.
   */
  EARN_PURCHASE_TEXT:
    '1 Coin por cada ₡100 que pagas, en la web o en la tienda. Se acreditan cuando se confirma tu pago; el envío no suma.',
  EARN_CODES_TITLE: 'Canjeando códigos',
  EARN_CODES_TEXT: 'Escribe en tu perfil los códigos de Perrón Coins que recibas en eventos, torneos y promociones.',
  EARN_QR_TITLE: 'Con tu QR en caja',
  EARN_QR_TEXT: 'En la tienda, enseña tu QR Perrón desde tu perfil y sumamos tus Coins al momento.',

  USE_TITLE: 'Para qué sirven',
  USE_VIP_TITLE: 'Acceso VIP',
  USE_VIP_TEXT: 'Con suficientes Coins desbloqueas precompras y productos exclusivos antes que nadie.',

  VALUE_TITLE: 'Muy pronto, Coins como dinero',
  /** `{valor}` = `formatCrc(coinValueCrc)`, de `GET /perron-coins/settings`. */
  VALUE_TEXT: 'Pronto podrás pagar con tus Coins en Perrón Store: cada Coin valdrá {valor}.',

  CTA_SIGNED_IN: 'Ver mis Coins',
  CTA_SIGNED_OUT: 'Inicia sesión para ver tus Coins',
} as const;
